import { ReadableStreamDefaultReader } from "stream/web";
import {
  cleanupStream,
  decodeChunk,
  extractEvents,
  processFirstChunk,
  processSSEEvent,
} from "./streamProcessing";

/**
 * Creates an async generator to process SSE stream
 * @param reader - ReadableStreamDefaultReader from fetch response
 * @param conversationId - Current conversation ID if any
 * @returns Async generator yielding processed stream chunks
 */
export function createStreamGenerator(
  reader: ReadableStreamDefaultReader<Uint8Array>,
  conversationId: number | null,
) {
  const decoder = new TextDecoder();
  let buffer = "";

  return {
    [Symbol.asyncIterator]: async function* () {
      try {
        let isFirstChunk = true;

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          const chunk = decodeChunk(value, decoder);
          buffer += chunk;

          if (isFirstChunk) {
            isFirstChunk = false;
            processFirstChunk(buffer, conversationId);
          }

          const [events, remainingBuffer] = extractEvents(buffer);
          buffer = remainingBuffer;

          for (const event of events) {
            const parsedEvent = processSSEEvent(event);
            if (!parsedEvent) continue;
            yield parsedEvent;
          }
        }
      } finally {
        cleanupStream(reader as any);
      }
    },
  };
}
